import type { GuestProfileActorRole } from "./types.ts";

const VIEW_ROLES = new Set<GuestProfileActorRole>([
  "admin",
  "general_manager",
  "front_office",
  "finance",
  "supervisor",
]);

const EDIT_ROLES = new Set<GuestProfileActorRole>([
  "admin",
  "general_manager",
  "front_office",
  "supervisor",
]);

const LOYALTY_ROLES = new Set<GuestProfileActorRole>([
  "admin",
  "general_manager",
  "front_office",
  "finance",
  "supervisor",
]);

const MARKETING_ROLES = new Set<GuestProfileActorRole>([
  "admin",
  "general_manager",
  "supervisor",
]);

const MERGE_ROLES = new Set<GuestProfileActorRole>([
  "admin",
  "general_manager",
  "supervisor",
]);

export function canViewGuestProfile(role: GuestProfileActorRole) {
  return VIEW_ROLES.has(role);
}

export function canEditGuestProfile(role: GuestProfileActorRole) {
  return EDIT_ROLES.has(role);
}

export function canManageGuestLoyalty(role: GuestProfileActorRole) {
  return LOYALTY_ROLES.has(role);
}

export function canManageGuestMarketing(role: GuestProfileActorRole) {
  return MARKETING_ROLES.has(role);
}

export function canMergeGuestProfile(role: GuestProfileActorRole) {
  return MERGE_ROLES.has(role);
}
